import { useNavigate } from "react-router";

import { ClientsTableColumnCustomization } from "@components/Tables/ClientsTable/UI/ClientsTableColumnCustomization";

export const ColumnSettings = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate("..", { viewTransition: true });
  };

  return (
    <ClientsTableColumnCustomization
      isOpen
      onClose={handleClose}
    />
  );
};
